import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiGatewayHelperService } from './../../app/services/apigateway-helper.service';
import { Observable } from 'rxjs';


@Injectable()
export class CreateUserAnalyticsService {
  private readonly userOrgInfo: any = {
    userId: '',
    orgId: ''
  }
  constructor(
    private readonly http: HttpClient, 
    private readonly apiGatewayHelperService: ApiGatewayHelperService,
  ) { }

  setUserInfo(userId, orgId, pubnubEventType) {
    this.userOrgInfo.userId = userId;
    this.userOrgInfo.orgId = orgId;
    this.userOrgInfo.pubnubEventType = pubnubEventType;
  }

  getUserOrgInfo() {
    return this.userOrgInfo;
  }

  userProductEntitlement(spaceId, productCode) : Observable<any> {
    return this.http.get(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + spaceId + '/create-user-analytics/product/' + productCode);
  }
}
